export default "__VITE_ASSET__5574658e__"